
        var result = require("!!../../../../../../node_modules/css-loader/index.js!./page-ribbon.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/layouts/profiles/page-ribbon.css
// module id = 322
// module chunks = 0